// extracted by mini-css-extract-plugin
export default {"v-application":"ChipStatus_v-application_Kkrhs","text-h1":"ChipStatus_text-h1_UTnpf","text-h2":"ChipStatus_text-h2_oNsEv","chip":"ChipStatus_chip_mpjR3"};